import React, { useState, useEffect } from 'react';
import { CustomModal } from '../../components/ui/CustomModal';
import { formatNumber, parseFormattedNumber, getLocalDateString, formatDateForInput } from '../../utils/helpers';

export const LiabilityModal = ({ isOpen, onClose, onSave, existingLiability }) => {
    const initialLiabilityState = {
        date: getLocalDateString(),
        type: 'Phải trả',
        subject: '',
        amount: 0,
        dueDate: '',
        status: 'Chưa thanh toán',
        attachmentUrl: null,
    };

    const [liability, setLiability] = useState(initialLiabilityState);
    const [selectedFile, setSelectedFile] = useState(null);

    useEffect(() => {
        if (existingLiability) {
            setLiability({
                ...existingLiability,
                date: formatDateForInput(existingLiability.date),
                dueDate: existingLiability.dueDate ? formatDateForInput(existingLiability.dueDate) : ''
            });
        } else {
            setLiability({...initialLiabilityState, date: getLocalDateString()});
        }
        setSelectedFile(null);
    }, [existingLiability, isOpen]);

    const handleInputChange = (e) => setLiability(p => ({...p, [e.target.name]: e.target.value}));
    
    const handleAmountChange = (e) => {
        const numValue = parseFormattedNumber(e.target.value);
        setLiability(p => ({ ...p, amount: numValue }));
    };
    
    const handleSubmit = (e) => {
        e.preventDefault();
        onSave(liability, selectedFile, !!existingLiability);
    };

    return (
        <CustomModal isOpen={isOpen} onClose={onClose} title={existingLiability ? "Sửa Phiếu Công Nợ" : "Tạo Phiếu Công Nợ Mới"} maxWidth="max-w-2xl">
            <form onSubmit={handleSubmit} className="space-y-4">
                <select name="type" value={liability.type} onChange={handleInputChange} className="w-full p-3 border rounded-md bg-white">
                    <option>Phải trả</option>
                    <option>Phải thu</option>
                </select>
                <input type="text" name="subject" placeholder="Đối tượng (VD: Nhà cung cấp A, Khách hàng B)" value={liability.subject} onChange={handleInputChange} className="w-full p-3 border rounded-md" required />
                <input type="text" name="amount" placeholder="Số tiền" value={formatNumber(liability.amount)} onChange={handleAmountChange} className="w-full p-3 border rounded-md" required />
                <div>
                    <label className="text-sm font-medium text-gray-700">Ngày tạo</label>
                    <input type="date" name="date" value={liability.date} onChange={handleInputChange} className="mt-1 w-full p-3 border rounded-md" />
                </div>
                 <div>
                    <label className="text-sm font-medium text-gray-700">Hạn thanh toán</label>
                    <input type="date" name="dueDate" value={liability.dueDate} onChange={handleInputChange} className="mt-1 w-full p-3 border rounded-md" />
                </div>
                 <div>
                  <label className="block text-sm font-medium text-gray-700">Tệp đính kèm</label>
                  <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])} className="mt-1 block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"/>
                  {selectedFile && <p className="text-xs text-gray-600 mt-1">Đã chọn: {selectedFile.name}</p>}
                  {!selectedFile && liability.attachmentUrl && <p className="text-xs text-gray-600 mt-1">Tệp hiện tại: {liability.attachmentUrl.split('/').pop()}</p>}
                </div>

                <div className="flex justify-end gap-3 pt-4 border-t">
                    <button type="button" onClick={onClose} className="py-2 px-5 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300">Hủy</button>
                    <button type="submit" className="py-2 px-5 bg-blue-600 text-white rounded-lg hover:bg-blue-700">Lưu</button>
                </div>
            </form>
        </CustomModal>
    );
};